export const textVariant = {
    '80': 'h1',
    '72': 'h1',
    '64': 'h1',
    '56': 'h1',
    '62': 'h1',
    '48': 'h2',
    '36': 'h3',
    '24': 'h4',
    '21': 'h5',
    '18': 'h6',
    '16': 'p',
    '14': 'p',
    80: 'h1',
    72: 'h1',
    64: 'h1',
    56: 'h1',
    62: 'h1',
    48: 'h2',
    36: 'h3',
    24: 'h4',
    21: 'h5',
    18: 'h6',
    16: 'p',
    14: 'p',
};

export const textClasses = {
    '80': 'display_1',
    '72': 'display_2',
    '64': 'display_3',
    '56': 'display_4',
    '62': 'header1',
    '48': 'header2',
    '36': 'header3',
    '24': 'header4',
    '21': 'header5',
    '18': 'header6',
    '16': 'normal',
    '14': 'small',
    80: 'display_1',
    72: 'display_2',
    64: 'display_3',
    56: 'display_4',
    62: 'header1',
    48: 'header2',
    36: 'header3',
    24: 'header4',
    21: 'header5',
    18: 'header6',
    16: 'normal',
    14: 'small',
};